import { AbstractHTMLHelpProperties } from "@lib/titan2/dist/game/view/properties/AbstractHTMLHelpProperties";
/**
 * SlingoHTMLHelpProperties
 */
export class SlingoHTMLHelpProperties extends AbstractHTMLHelpProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.superSpinWheelElements = ["superspin", "superspinwheel", "superspingamble"];
        this.superSpinWheelMaxSpinElements = "help.slingo.standard.superspinwheel.line7";
    }
}
//# sourceMappingURL=SlingoHTMLHelpProperties.js.map